import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'react-emotion';
import withDirection from '~/modules/core/utils/mediaHelpers/withDirection';

const PortalWrapper = withDirection(styled.div`
  &&& {
    display: none;
    &&.active {
      display: flex;
    }
    position: absolute;
    ${props => (props.direction === 'rtl'
    ? css`
        right: 102%;
      `
    : css`
        left: 102%;
    `)}

    top: 0;
    height: 400px;
    width: 800px;
    z-index: 1;
    align-items: center;
    justify-content: flex-start;
    .portal {
      background-color: #ffffff;
      direction: ltr;
      div {
        border-radius: ${props => props.theme.borders.radius.normal}px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #cfcfcf;
        ${props => props.direction === 'rtl'
        && css`
            margin-left: 0 !important;
            left: calc(-100% - 30px) !important;
        `}
      }
    }
    img {
      object-fit: cover !important;
      border-radius: ${props => props.theme.borders.radius.normal}px;
    }
  }
`);

const ImageZoomPortalView = ({ className }) => (
  <PortalWrapper className={className}>
    <div
      id="portal"
      className="portal"
    />
  </PortalWrapper>
);
ImageZoomPortalView.propTypes = {
  className: PropTypes.string,
};
ImageZoomPortalView.defaultProps = {
  className: null,
};
export default ImageZoomPortalView;
